import { TemplateInformation } from '../types';

export function useCheckInformation(
  checkedValues: Record<string, string | boolean> | undefined,
  information?: TemplateInformation
) {
  return checkedValues?.[information?.key as string];
}
